document.addEventListener("DOMContentLoaded", () => {
  const carouselContainer = document.querySelector(
    ".static-card-carousel .embla"
  );
  if (!carouselContainer) return;

  const viewport = carouselContainer.querySelector(".embla__viewport");
  if (!viewport) return;

  let embla = null;

  const initCarousel = () => {
    embla = EmblaCarousel(viewport, {
      loop: false,
      draggable: true,
      slidesToScroll: 1,
    });
  };

  initCarousel();

  const readMoreButtons = document.querySelectorAll(
    ".static-card-carousel .read-more-btn"
  );

  readMoreButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const card = button.closest(".static-card-carousel-item");
      const contentInner = card.querySelector(".card-content-inner");
      const readMoreText = button.querySelector(".read-more-text");
      const readLessText = button.querySelector(".read-less-text");
      const isExpanded = button.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        contentInner.classList.remove("expanded");
        contentInner.classList.add("collapsed");
        button.setAttribute("aria-expanded", "false");
        readMoreText.classList.remove("is-hidden");
        readLessText.classList.add("is-hidden");
      } else {
        contentInner.classList.remove("collapsed");
        contentInner.classList.add("expanded");
        button.setAttribute("aria-expanded", "true");
        readMoreText.classList.add("is-hidden");
        readLessText.classList.remove("is-hidden");
      }
    });
  });
});
